import axios from 'services/network/axios';

export const GetByCourseId = (id) => axios.get(`Level/GetByCourseId?courseId=${id}`);
export const GetDetails = (levelId) => axios.get(`Level/GetDetails?LevelId=${levelId}`);

export const SetPending = (levelId) => axios.post(`Level/SetPending?LevelId=${levelId}`);

export const UserText = (data) => axios.post('Level/UserText', data);
export const UserUpload = (data) => axios.post('Level/UserUpload', data, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
    }
});

export const GetMedia = (address) => axios.get(`Media/Get?address=${address}`, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/octet-stream'
    }
});

export const GetAdminByCourseId = (id) => axios.get(`Level/GetAdminByCourseId?courseId=${id}`);

export const GetAdminDetails = (levelId, userId) => axios.get(`Level/GetAdminDetails?levelId=${levelId}&userId=${userId}`);

export const GetCmsAdminDetails = (levelId) => axios.get(`Level/GetCmsAdminDetails?id=${levelId}`);

export const GetAdminLevel = (levelId) => axios.get(`Level/GetAdminLevel?id=${levelId}`);

export const AdminText = (data) => axios.post('Level/AdminText', data);
export const AdminUpload = (data) => axios.post('Level/AdminUpload', data, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
    }
});

export const SetAdminPending = (levelId, userId, state) => axios.post(`Level/SetAdminPending?LevelId=${levelId}&userId=${userId}&state=${state}`);

export const AdminCmsText = (data) => axios.post('Level/AdminCmsText', data);
export const AdminCmsUpload = (data) => axios.post('Level/AdminCmsUpload', data, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
    }
});
export const AdminCmsDelete = (data) => axios.post('Level/AdminCmsDelete', data);


export const Create = (data) => axios.post('Level/Create', data);

export const Update = (data) => axios.post('Level/Update', data);
export const UpdateLevelDescription = (data) => axios.post('Level/UpdateLevelDescription', data);

export const Delete = (id) => axios.post(`Level/Delete?id=${id}`);
